import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

export const YouTube = ({ size, color, x = '0px', y = '0px', scale = 0 }: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={size || '40px'}
      height={size || '40px'}
      scale={scale || 0}
      x={x}
      y={y}
      viewBox="0 0 40 40"
      fill={color || 'currentColor'}
    >
      <path
        d="M37.645,11.168c-0.21-0.835-0.621-1.597-1.192-2.209c-0.571-0.612-1.283-1.053-2.063-1.278
        C31.516,6.854,20,6.854,20,6.854s-11.516,0-14.389,0.822C4.83,7.901,4.118,8.342,3.547,8.954c-0.571,0.612-0.982,1.374-1.191,2.21
        c-0.769,3.079-0.769,9.5-0.769,9.5s0,6.421,0.769,9.495c0.423,1.698,1.673,3.035,3.255,3.488C8.484,34.474,20,34.474,20,34.474
        s11.516,0,14.389-0.827c1.586-0.453,2.832-1.79,3.255-3.488c0.769-3.074,0.769-9.495,0.769-9.495S38.413,14.243,37.645,11.168z
        M16.342,26.557V14.77l9.535,5.849L16.342,26.557z"
        fill={color || 'currentColor'}
      />
    </StyledSvg>
  );
};
